import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useGetCreateBookingQuery } from "../bookingsApiSlice";

const CheckoutSuccess = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const searchParams = new URLSearchParams(location.search);
  const tour: string = searchParams.get("tour") || "test";
  const user = searchParams.get("user");
  const price = searchParams.get("price");
  const startDate = searchParams.get("startDate");

  // api call
  useGetCreateBookingQuery({ tour, user, price, startDate });

  // Navigate to the account page once the booking has been recorded
  useEffect(() => {
    navigate("/manage-account");
  }, [navigate]);

  return <div>index</div>;
};

export default CheckoutSuccess;
